import React from "react";
import { Link, useLocation } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";


const Sidebar = () => {
  const location = useLocation();
  const navLinks = [
    { to: "/dashboard", icon: "bi-bar-chart-line", label: "Dashboard" },
    { to: "/students", icon: "bi-people", label: "Students" },
    { to: "/categories", icon: "bi-layers", label: "Course Categories" },
    { to: "/course", icon: "bi-journal-bookmark", label: "Courses" },
    { to: "/approvals", icon: "bi-check2-square", label: "Approvals" },
    { to: "/progress", icon: "bi-file-earmark", label: "Progress Tracker" },
   { to: "/registered", icon: "bi bi-person-lines-fill", label: "Registered Students" },
  ];
  return (
    <>
      {/* Sidebar for large screens */}
      <aside
        className="d-none d-lg-flex flex-column bg-white border-end"
        style={{
          height: "100vh",
          minHeight: 0,
          width: "260px",
          minWidth: "220px",
          overflowY: "auto",
        }}
      >
        <div className="px-4 pt-4 pb-2 border-bottom">
          {/* Logo Image */}
          <img
            src="/logo.png"
            alt="Internskool Logo"
            width={32}
            height={32}
            style={{ borderRadius: "8px" }}
          />
          <span className="fw-bold fs-4" style={{ marginLeft:"8px" }}>Internskool</span>
        </div>

        <nav className="flex-grow-1 px-2 py-3">
          <ul className="nav flex-column gap-1">
            {navLinks.map((link) => (
              <li className="nav-item" key={link.to}>
                <Link
                  className={`nav-link d-flex align-items-center gap-2${
                    location.pathname === link.to
                      ? " active text-primary fw-bold"
                      : " text-dark"
                  }`}
                  to={link.to}
                  style={
                    location.pathname === link.to
                      ? { background: "#e7f1ff", borderRadius: "6px" }
                      : {}
                  }
                >
                  <i className={`bi ${link.icon}`}></i>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
      {/* Offcanvas sidebar for small screens (same icons) */}
      <div className="d-lg-none">
        <button
          className="btn btn-outline-secondary m-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#sidebarOffcanvas"
          aria-controls="sidebarOffcanvas"
        >
          <i className="bi bi-list"></i>
        </button>
        <div
          className="offcanvas offcanvas-start"
          tabIndex="-1"
          id="sidebarOffcanvas"
          aria-labelledby="sidebarOffcanvasLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="sidebarOffcanvasLabel">
              Interskool
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div
            className="offcanvas-body p-0"
            style={{ height: "100vh", minHeight: 0, overflowY: "auto" }}
          >
            {/* Sidebar content reused here */}
            <aside
              className="flex-column bg-white border-end"
              style={{ width: "100%" }}
            >
              <div className="px-4 pt-4 pb-2 border-bottom">
                <div className="d-flex align-items-center gap-2">
                  {/* Logo Image */}
                  <img
                    src="/logo.png"
                    alt="Internskool Logo"
                    width={32}
                    height={32}
                    style={{ borderRadius: "8px" }}
                  />
                  <span className="fw-bold fs-4">Internskool</span>
                </div>
              </div>
              <nav className="px-2 py-3">
                <ul className="nav flex-column gap-1">
                  <li className="nav-item">
                    <Link
                      className="nav-link active d-flex align-items-center gap-2"
                      to="/dashboard"
                      style={{ background: "#f5f5f5", borderRadius: "6px" }}
                    >
                      <i className="bi bi-bar-chart-line"></i>
                      Dashboard
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link d-flex align-items-center gap-2 text-dark"
                      to="/students"
                    >
                      <i className="bi bi-people"></i>
                      Students
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link d-flex align-items-center gap-2 text-dark"
                      to="/categories"
                    >
                      <i className="bi bi-layers"></i>
                      Course Categories
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link d-flex align-items-center gap-2 text-dark"
                      to="/course"
                    >
                      <i className="bi bi-journal-bookmark"></i>
                      Courses
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      className="nav-link d-flex align-items-center gap-2 text-dark"
                      to="/approvals"
                    >
                      <i className="bi bi-check2-square"></i>
                      Approvals
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      className="nav-link d-flex align-items-center gap-2 text-dark"
                      to="/progress"
                    >
                      <i className="bi bi-file-earmark"></i>
                      Progress Tracker
                    </Link>
                  </li>
                    <li className="nav-item">
                    <Link className="nav-link d-flex align-items-center gap-2 text-dark" to="/registered">
                      <i className="bi bi-file-earmark"></i>
                      Registered Students
                    </Link>
                  </li>
                </ul>
              </nav>
            </aside>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
